import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Box, colors, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { findcountryMasterAddAction } from "../../../actions/countryMasterAction";
import {
  changeSopApplicationStatusAction,
  leadDocumentDeleteAction,
  leadSopFindingAction,
  leadSopUploadingAction
} from "../../../actions/leadActions/leadDocsActions";
import { useParams } from "react-router-dom";
import { Chip } from "@material-ui/core";
import CountryFlag from "../../customComponent/CountryFlag";
import Swal from "sweetalert2";
import { successTrueMsgAction } from "../../../actions/globalAction";
import { IoEyeOutline } from "react-icons/io5";
import { CiRepeat } from "react-icons/ci";
import { AiTwotoneDelete } from "react-icons/ai";
import { GoDownload } from "react-icons/go";
import { LEAD_DOCUMENT_DELETE_SUCCESS } from "../../../constants/leadConstant";

function SopDetails({ handleComplete, handleCompleteTick }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [hoveredIcon, setHoveredIcon] = useState(null);

  // Selectors
  const {
    countryFindSuccess,
    leadSopUploadingSuccess,
    leadSopFindingSuccess,
    leadSopStatusChangeSuccess,
    leadDocumentDeleteSuccess,
    successAlertMsgSuccess
  } = useSelector((state) => ({
    countryFindSuccess: state.findcountryMasterAdd.countryFindSuccess,
    leadSopUploadingSuccess: state.leadSopUploading.leadSopUploadingSuccess,
    leadSopFindingSuccess: state.leadSopFinding.leadSopFindingSuccess,
    leadSopStatusChangeSuccess: state.changeSopApplicationStatus.leadSopStatusChangeSuccess,
    leadDocumentDeleteSuccess: state.leadDocumentDelete.leadDocumentDeleteSuccess,
    successAlertMsgSuccess: state.successTrueMsg.successAlertMsgSuccess
  }));

  // State for status verification and country list
  const [statusVerify, setStatusVerify] = useState({});
  const [countryList, setCountryList] = useState([]);

  console.log(48,leadSopFindingSuccess);
  

  // Memoized country list calculation
  const memoizedCountryList = useMemo(() => {
    if (countryFindSuccess && leadSopFindingSuccess) {
      return countryFindSuccess.filter((country) => 
        !leadSopFindingSuccess.some((sop) => sop.countryName === country.countryName)
      );
    }
    return [];
  }, [countryFindSuccess, leadSopFindingSuccess]);

  // Update country list when dependencies change
  useEffect(() => {
    setCountryList(memoizedCountryList);
  }, [memoizedCountryList]);

  // Fetch country and SOP data
  useEffect(() => {
    console.log(149,"sop finding useeffect is working");
    dispatch(findcountryMasterAddAction(id, "sop"));
    dispatch(leadSopFindingAction(id));
  }, [dispatch, id, leadSopUploadingSuccess, leadSopStatusChangeSuccess, leadDocumentDeleteSuccess]);

  // Success alerts
  useEffect(() => {
    if (leadSopUploadingSuccess && successAlertMsgSuccess) {
      Swal.fire({
        icon: "success",
        title: "Good job \u{1F44D}",
        text: "SOP Uploaded Successfully"
      });
      dispatch(successTrueMsgAction(false));
    }
  }, [leadSopUploadingSuccess, successAlertMsgSuccess, dispatch]);

  console.log(149,"sop upload success",leadSopUploadingSuccess);

  // Handle SOP document change
  const handleSopDocChange = useCallback((event, countryId, countryName) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      dispatch(leadSopUploadingAction(reader.result, countryId, id, countryName));
      dispatch(successTrueMsgAction(true));
    };
    reader.readAsDataURL(file);
  }, [dispatch, id]);

  // Handle status verification toggle
  const toggleStatusVerify = useCallback((index, value) => {
    setStatusVerify(prev => ({ ...prev, [index]: value }));
  }, []);

  // Handle document deletion
  const handleDeleteDocument = useCallback((docId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(leadDocumentDeleteAction(docId, id, "sop"));
        Swal.fire("Deleted!", "Your file has been deleted.\u{1F44D}", "success");
      }
    });
  }, [dispatch, id]);

  // Handle status change
  const handleStatusChange = useCallback((leadId, countryId, status, type) => {
    dispatch(changeSopApplicationStatusAction(leadId, countryId, status, type));
  }, [dispatch]);

  // Icon style configuration
  const iconStyle = {
    width: "22px",
    height: "22px",
    marginRight: "10px",
    transition: "color 0.3s ease"
  };

  const iconHoverStyle = {
    color: "red"
  };

  const handleMouseEnter = useCallback((icon) => setHoveredIcon(icon), []);
  const handleMouseLeave = useCallback(() => setHoveredIcon(null), []);

  // Render helper functions
  const renderUploadBox = (data) => (
    <Box
      sx={{
        height: 82,
        bgcolor: "white",
        border: "1.5px dashed rgba(25, 118, 210, 0.5)",
        borderRadius: 1
      }}
    >
      <label
        htmlFor={`avatar-file-${data.id}`}
        style={{ 
          margin: 15,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer"
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <div className="rounded-flag"> */}
            <CountryFlag
              countryCode={data.countryCode}
              component="stepper"
              width={39}
              height={39}
            />
            <Typography variant="body1" ml={1.25}>
              {data.countryName.split("(")[0]}
            </Typography>
          {/* </div> */}
        </div>

          {/* <div style={{ marginLeft: "10px" }}> */}
            {/* <Typography
              sx={{
                fontWeight: 400,
                fontSize: "18px",
                lineHeight: "24px",
                fontFamily: "Montserrat,sans-serif"
              }}
            >
              {data?.countryName.split("(")[0]}
            </Typography> */}
          {/* </div> */}
        <div style={{ display: "flex", alignItems: "center" }}>
        <img src="/menuIcons/uploadBlue.png" alt="upload" />
          <Typography color="primary" ml={1} fontFamily="Montserrat">
            Upload
          </Typography>
        </div>
      </label>
      <input
        type="file"
        accept=".pdf,.doc,.docx,.xlsx"
        id={`avatar-file-${data.id}`}
        style={{ display: "none" }}
        onChange={(e) => handleSopDocChange(e, data.id, data.countryName)}
      />
    </Box>
  );

  const renderStatusChips = (sopData, index) => (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(8px)",
        opacity: 0,
        transition: "opacity 0.3s",
        zIndex: 1,
        "&:hover": { opacity: 1 },
        gap: "10px",
      }}
    >
      <Chip
        label="Reupload"
        color="warning"
        variant="outlined"
        sx={{
          borderColor: "warning.main",
          color: "warning.main",
          cursor: "pointer"
        }}
        onClick={() => {
          handleStatusChange(sopData.leadId, sopData.countryId, "reupload", "sop");
          toggleStatusVerify(index, false);
        }}
      />
      <Chip
        label="Verify"
        color="success"
        variant="outlined"
        sx={{
          color: "rgba(50, 157, 0, 1)",
          borderColor: "rgba(50, 157, 0, 1)",
          marginLeft: "10px",
          position: "relative",
          zIndex: 2,
          cursor: "pointer"
        }}
        onClick={() => {
          handleStatusChange(sopData.leadId, sopData.countryId, "verified", "sop");
          toggleStatusVerify(index, false);
        }}
      />
        <Chip
          label="close"
          color="error"
          variant="outlined"
          sx={{
            marginLeft: "10px",
            position: "relative",
            zIndex: 2,
            cursor: "pointer",
            color: "error.main", // Use theme color
            borderColor: "error.main", // Ensure border matches
            '&:hover': {
              backgroundColor: 'error.light', // Optional hover effect
            }
          }}
          onClick={() => toggleStatusVerify(index, false)}
        />
    </Box>
  );

  const renderActionIcons = (sopData, index) => (
    <>
      <a
        href={sopData.pdfUrl}
        download={sopData.pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Tooltip title="view">
          <IconButton 
          // sx={{ padding: 0, marginRight: "10px" }}
          >
            <IoEyeOutline
              style={{
                ...iconStyle,
                color: hoveredIcon === "eye" ? iconHoverStyle.color : "black",
                cursor: "pointer"
              }}
              onMouseEnter={() => handleMouseEnter("eye")}
              onMouseLeave={handleMouseLeave}
            />
          </IconButton>
        </Tooltip>
      </a>

      {sopData.status !== "approved" && (
        <Tooltip title="Change status">
          <IconButton sx={{ padding: 0, marginRight: "10px" }}>
            <CiRepeat
              style={{
                ...iconStyle,
                color: hoveredIcon === "repeat" ? iconHoverStyle.color : "black",
                cursor: "pointer"
              }}
              onMouseEnter={() => handleMouseEnter("repeat")}
              onMouseLeave={handleMouseLeave}
              onClick={() => toggleStatusVerify(index, true)}
            />
          </IconButton>
        </Tooltip>
      )}

      <a
        href={sopData.pdfUrl}
        download={sopData.pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Tooltip title="Download">
          <IconButton sx={{ padding: 0, marginRight: "10px" }}>
            <GoDownload
              style={{
                ...iconStyle,
                color: hoveredIcon === "download" ? iconHoverStyle.color : "black",
                cursor: "pointer"
              }}
              onMouseEnter={() => handleMouseEnter("download")}
              onMouseLeave={handleMouseLeave}
            />
          </IconButton>
        </Tooltip>
      </a>

      {sopData.status !== "verified" && sopData.status !== "approved" && (
        <Tooltip title="Delete">
          <IconButton sx={{ padding: 0, marginRight: "10px" }}>
            <AiTwotoneDelete
              style={{
                ...iconStyle,
                color: hoveredIcon === "delete" ? iconHoverStyle.color : "black",
                cursor: "pointer"
              }}
              onMouseEnter={() => handleMouseEnter("delete")}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleDeleteDocument(sopData.id)}
            />
          </IconButton>
        </Tooltip>
      )}
    </>
  );

  return (
    <Grid container spacing={2} p={1.25}>
      {countryList.length === 0 && leadSopFindingSuccess?.length === 0 && (
        <Typography
        variant="body1"
        textAlign="center"
        mt={10}
        fontFamily="Montserrat"
        >
          No documents to show. Add your preferred country or Add document in Knowledge bank
        </Typography>
      )}

      {countryList.map((data) => (
        <Grid item xs={6} md={4} lg={3} key={data.id}>
          <Box my={2}>{renderUploadBox(data)}</Box>
        </Grid>
      ))}

      {leadSopFindingSuccess?.map((sopData, index) => (
        <Grid item xs={6} md={4} lg={3} key={`${sopData.id}-${index}`}>
          <Box mt={1} mb={5} position="relative">
            <Box
              sx={{
                height: 82,
                bgcolor: "white",
                border: "1.5px dashed rgba(255, 153, 0, 1)",
                borderRadius: 2
              }}
            >
              <Box display="flex" justifyContent="space-between" m={1.25}>                {/* <div style={{ display: "flex", alignItems: "center" }}> */}
                  <Box display="flex" alignItems="center">
                    <CountryFlag
                      countryCode={sopData.countryCode.countryCode}
                      component="stepper"
                      width="39px"
                      heigth="39px"
                    />
                  <Box ml={1.25}>
                    <Typography variant="body1">
                    {sopData?.countryName.split("(")[0]}
                    </Typography>
                    <Box display="flex">
                    {!statusVerify[index] && renderActionIcons(sopData, index)}
                    </Box>
                  </Box>
                  </Box>
                <Box display="flex" flexDirection="column" alignItems="flex-end">
                  <Typography color="success.main" fontFamily="Montserrat">
                    Uploaded
                  </Typography>
                  <Typography
                    color={["verified", "approved"].includes(sopData.status)
                      ? "success.main"
                      : "warning.main"}
                    textTransform="capitalize"
                  >
                    {sopData.status}
                  </Typography>
                </Box>
                </Box>
              {statusVerify[index] && renderStatusChips(sopData, index)}
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default React.memo(SopDetails);